import React, { useState } from "react";
import { AssignGroupContext } from "./context";

const GroupWapper = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [lastEditGroup, setLastEditGroup] = useState(null);
  const [isDeleteMode,setIsDeleteMode] = useState(false);
  const [dialogDeleteOpen,setDialogDeleteOpen] = useState(false);

  return (
    <AssignGroupContext.Provider
      value={{
        dialogOpen,
        setDialogOpen,
        isEditMode,
        setIsEditMode,
        lastEditGroup,
        setLastEditGroup,
        dialogDeleteOpen,
        setDialogDeleteOpen,
        isDeleteMode,
        setIsDeleteMode
      }}
    >
      {children}
    </AssignGroupContext.Provider>
  );
};

export default GroupWapper;
